import { render, staticRenderFns } from "./CreateBranchForm.vue?vue&type=template&id=730ad128"
import script from "./CreateBranchForm.vue?vue&type=script&lang=js"
export * from "./CreateBranchForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports